export default __webpack_public_path__ + "98738a576ab66cccfe40bc91e313e92d.png";